/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type AffirmPromo_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AffirmPromo_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AffirmDisplay_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Affirm/__generated__/AffirmPromo_user.graphql.js